import React from "react";
import ServicesContentContainer from "../components/ServicesContentContainer";
import MainSection from "../components/MainSection";

const Vg = () => {
  const contentData = [
    {
      id: 1,
      title: "Preliminary Visa Counseling",
      description:
        "At the outset, we will provide a broad overview of the visa process. We will outline the different visa categories, discuss the requirements for each one, and help you determine which visa best aligns with your education and career goals.",
    },
    {
      id: 2,
      title: "Document Review",
      description:
        "Proper documentation is critical in the visa application process. Our team will review your documents meticulously to ensure everything is in order, including your passport, proof of acceptance at a foreign institution, financial documents, and any other paperwork pertinent to your specific visa category.",
    },
    {
      id: 3,
      title: "Application Assistance",
      description:
        "We understand that filling out visa applications can be a daunting task. Our team will guide you through the application process step-by-step, providing expert advice and support to ensure your application is correctly filled out and complete.",
    },
    {
      id: 4,
      title: "Preparation for Visa Interview",
      description:
        "Visa interviews can be stressful, but preparation is key. We offer mock interview sessions where we go over potential questions, help you prepare responses, and provide feedback to improve your performance. We also advise on the proper etiquette and what to expect on the day of your interview.",
    },
    {
      id: 5,
      title: "Tracking the Application Status",
      description:
        "After you've submitted your application and completed your interview, we'll continue to track your application status. We'll keep you updated and promptly notify you of any additional steps you need to take.",
    },
    {
      id: 6,
      title: "Post-Visa Guidance",
      description:
        "Once you've obtained your visa, our support doesn't end. We provide guidance on travel, accommodation, and living in your new country. We also offer advice on compliance with the terms of your visa to avoid any legal issues.",
    },
  ];
  const conclusion =
    "Visa applications can be complicated, but we're here to make it easier. Through every step of the process, we offer guidance, support, and expert advice to make your journey to studying abroad as smooth as possible. We understand that every student's situation is unique, so our services are tailored to meet your specific needs and circumstances. Don't hesitate to contact us for any of your visa guidance needs.";
  return (
    <>
      <MainSection bannerTxt="VISA GUIDANCE" color="gray" />
      <ServicesContentContainer
        contentData={contentData}
        conclusion={conclusion}
        title={"Visa Processes"}
        includeTxt={""}
      />
    </>
  );
};

export default Vg;
